import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FEATURED_PROJECTS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const FeaturedProjects = () => {
    const ref = useReveal();
    // Use first 6 for a rich masonry
    const items = FEATURED_PROJECTS;

    // Height variants for a masonry feel
    const heights = [
        "h-[420px] md:h-[520px]",
        "h-[320px] md:h-[400px]",
        "h-[480px] md:h-[600px]",
        "h-[360px] md:h-[440px]",
        "h-[420px] md:h-[540px]",
        "h-[380px] md:h-[480px]",
    ];

    return (
        <section
            ref={ref}
            data-testid="featured-projects-section"
            className="py-24 md:py-40 bg-samora-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24 reveal">
                    <div>
                        <p className="eyebrow mb-6">
                            Featured Work · 2023–2024
                        </p>
                        <h2
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
                        >
                            A handful of homes,<br />
                            <span className="italic font-serif text-samora-gold">
                                fully lived-in.
                            </span>
                        </h2>
                    </div>
                    <Link
                        to="/portfolio"
                        data-testid="featured-view-all"
                        className="btn-ghost-gold"
                    >
                        View All Projects <ArrowUpRight size={14} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {items.map((p, i) => (
                        <Link
                            key={p.id}
                            to={`/portfolio/${p.id}`}
                            data-testid={`featured-project-${p.id}`}
                            className={`group reveal block ${
                                i === 0
                                    ? "md:col-span-2 lg:col-span-2 lg:row-span-2"
                                    : ""
                            }`}
                        >
                            <div
                                className={`img-hover-wrap w-full ${
                                    i === 0
                                        ? "h-[520px] md:h-[720px] lg:h-[820px]"
                                        : heights[i % heights.length]
                                }`}
                            >
                                <img src={p.cover} alt="Samora Spaces featured interior" />
                                <div className="img-hover-overlay">
                                    <div className="text-white w-full flex items-end justify-end">
                                        <ArrowUpRight
                                            size={22}
                                            strokeWidth={1.5}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 flex items-start justify-end gap-6">
                                <ArrowUpRight
                                    size={20}
                                    className="text-samora-ink mt-2 group-hover:text-samora-gold transition-colors"
                                />
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedProjects;
